<template>
    <f7-page name="video-message-details">
        <bc-navbar></bc-navbar>
        <br />
        <div class="layout_fullwidth_padding">
            <div v-bind:class="{ none: !isRequestActive }" class="loader">
                <looping-rhombuses-spinner :animation-duration="2500" :rhombus-size="15" color="#f9f300" />
            </div>
            <a v-on:click="back">
                <img src="/static/images/icons/black/back.png" alt="" class="back_image_button" title="">
            </a>
            <div v-if="selectedVideoMessage">
                <h3 style="font-weight: 700;">{{selectedVideoMessage.title}}</h3>
                <div id="youtubeIframe" v-if="selectedVideoMessage.youTubeId"></div>
                <video v-if="selectedVideoMessage.url && !selectedVideoMessage.youTubeId"
                       id="player"
                       controls>
                </video>
                <div v-html="selectedVideoMessage.message"></div>
                <img style="width:100%" :src="selectedVideoMessage.backgroundImageUrl" />
                <h6><i class="fa fa-calendar-check-o" aria-hidden="true"></i> {{getDateAndTime(selectedVideoMessage.sendDate)}}</h6>
                <a @click="redirectTo(selectedVideoMessage.backgroundSiteUrl)"
                   :href="selectedVideoMessage.backgroundSiteUrl"
                   :style="borderStyle" class="button_full btyellow external">
                    Read More
                </a>
            </div>
        </div>
    </f7-page>
</template>
<script>
    /* eslint-disable */
    import { mapState } from "vuex";
    import { LoopingRhombusesSpinner } from "epic-spinners";
    import { VideoPlayer } from "../../../static/video-player"

    export default {
        components: {
            LoopingRhombusesSpinner
        },

        mounted: function () {
            this.isRequestActive = true;
            this.$store
                .dispatch("videoMessage/loadSelectedVideoMessage", this.messageId)
                .then(() => {
                    this.isRequestActive = false;
                    if (this.selectedVideoMessage.url) {
                        let url = this.selectedVideoMessage.url;
                        let poster = this.selectedVideoMessage.thumbnail;
                        this.player = new VideoPlayer(document.querySelector('#player'));
                        this.player.init(url, poster);
                        this.player.onPlay(() => {
                            if (!this.isPlayed) {
                                this.isPlayed = true;
                                this.setVideoMessagePlays()
                            }
                        })
                    }
                    else {
                        var scriptTag = document.getElementById('YTApi');
                        if (scriptTag === undefined || scriptTag === null) {
                            var tag = document.createElement('script');
                            tag.src = "https://www.youtube.com/iframe_api";
                            tag.id = "YTApi";
                            var firstScriptTag = document.getElementsByTagName('script')[0];
                            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

                            window.onYouTubeIframeAPIReady = function () {
                                this.YTplayer = new YT.Player('youtubeIframe', {
                                    videoId: this.selectedVideoMessage.youTubeId,
                                    width: '100%;',
                                    height: '200px',
                                    events:
                                    {
                                        'onStateChange': this.setVideoMessagePlaysYT
                                    }
                                });
                            }.bind(this);
                        }
                        else {
                            this.YTplayer = new YT.Player('youtubeIframe', {
                                videoId: this.selectedVideoMessage.youTubeId,
                                width: '100%;',
                                height: '200px',
                                events:
                                {
                                    'onStateChange': this.setVideoMessagePlaysYT
                                }
                            });
                        }
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    this.$router.load({ url: "video-message" });
                });
            window.onpopstate = function () {
                if (this.player) {
                    this.player.detach();
                }
            }.bind(this);
        },
        beforeDestroy() {
            if (this.player) {
                this.player.detach();
            }
        },
        computed: {
            ...mapState({
                selectedVideoMessage: state => state.videoMessage.selectedVideoMessage,
                customization: state => state.common.customization
            }),
            borderStyle: function () {
                var borderStyle = this.customization.borderOn ? 'solid 1px ' + this.customization.borderColor : 'none';
                var backgroundStyle = this.customization.mainColor;
                var colorStyle = this.customization.fontColor
                return {
                    border: borderStyle,
                    background: backgroundStyle,
                    color: colorStyle
                };
            }
        },
        methods: {
            getDateAndTime(time) {
                var date = new Date(time);
                return (
                    date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear()
                );
            },
            setVideoMessagePlaysYT(event) {
                if (event.data === -1)
                    this.setVideoMessagePlays();
            },
            setVideoMessagePlays() {
                this.$store.dispatch("videoMessage/setVideoMessagePlaysMetric", this.messageId)
                    .then(() => {
                        console.log("setVideoMessagePlays succsess");
                    });
            },
            setVideoMessageBackgroundViews() {
                this.$store.dispatch("videoMessage/setVideoMessageBackgroundViewsMetric", this.messageId)
                    .then(() => {
                        console.log("setVideoMessagePlays succsess");
                    });
            },
            redirectTo(url) {
                this.setVideoMessageBackgroundViews();
                // return window.open(url)
            },
            back() {
                if (this.player) {
                    this.player.detach();
                }
                if (this.YTplayer) {
                    this.YTplayer.destroy();
                }
                this.$router.load({ url: "video-message" });
            }
        },
        data() {
            return {
                isRequestActive: false,
                messageId: this.$route.params.id,
                player: null,
                YTplayer: null,
                isPlayed: false
            };
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .button_full {
        margin-top: 20px;
    }

    select {
        width: 100%;
        height: 35px;
    }

    h5 {
        font-weight: bold;
        padding: 10px 0 10px 0;
    }


    .loader {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgb(255, 255, 255);
        z-index: 9999999;
    }

    .none {
        display: none;
    }

    .video_message_title {
        width: 95%;
        font-size: 16px;
        line-height: 25px;
        font-weight: 300;
        padding: 10px 0 10px 5%;
        margin: 0px 0 15px 0;
        background-color: #f9f301;
        display: inline-block;
        letter-spacing: -0.5px;
    }

    body {
        overflow-x: hidden;
    }

    iframe {
        width: 100%;
        min-height: 200px;
    }

    video{
        aspect-ratio: 16 / 9;
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// video-message-details.vue?fa6735da